<template>
  <v-card
    :color="cardColor"
    :elevation="elevation"
    :flat="flat"
    :max-width="maxWidth"
    :min-width="minWidth"
    :tile="tile"
    :width="width"
  >
    <v-toolbar
      :class="toolbarClass"
      :color="coloredBorder ? '' : color"
      :dark="coloredBorder ? undefined: dark"
      :dense="dense"
      :extended="toolbarExtended"
      :height="toolbarHeight"
      :max-height="toolbarExtended ? parseInt(toolbarHeight) + 48 : parseInt(toolbarHeight)"
      :tile="tile"
      flat
    >
      <div
        :class="[coloredBorder ? `${color}--text v-alert__border--has-color` : '']"
        class="v-alert__border v-alert__border--left"
      />

      <slot
        :data="{icon: icon, color: color, coloredBorder: coloredBorder}"
        name="toolbar-avatar"
      >
        <v-avatar
          v-if="icon"
          :color="coloredBorder ? `${color} lighten-3` : `${color} lighten-1`"
          class="mr-2"
          size="36"
        >
          <v-icon :color="coloredBorder ? `${color}` : ''">
            {{ icon }}
          </v-icon>
        </v-avatar>
      </slot>

      <v-divider
        v-if="divider"
        class="mr-2"
        vertical
      />

      <v-toolbar-title v-if="title || subTitle">
        <div
          v-if="title"
          :class="[coloredBorder ? `${color}--text` : '']"
          class="subtitle-1"
        >
          {{ title }}
        </div>
        <div
          v-if="subTitle"
          :class="[coloredBorder ? 'grey--text text--darken-1' : `${color}--text text--lighten-4`]"
          class="caption"
        >
          {{ subTitle }}
        </div>
      </v-toolbar-title>

      <v-spacer />
      <slot name="toolbar-append" />

      <v-progress-linear
        :active="loading"
        :color="`${color} darken-3`"
        :indeterminate="loading"
        absolute
        bottom
        height="2"
      />

      <template
        v-if="toolbarExtended"
        #extension
      >
        <slot name="toolbar-extension" />
      </template>
    </v-toolbar>

    <v-divider />

    <slot name="default">
      <v-card-text />
    </slot>

    <slot name="card-actions" />
  </v-card>
</template>

<script>
export default {
  name      : 'DataCard',
  components: {},
  directives: {},
  mixins    : [],
  props     : {
    loading: {
      type   : Boolean,
      default: false
    },
    title: {
      type   : String,
      default: ''
    },
    subTitle: {
      type   : String,
      default: ''
    },
    icon: {
      type   : String,
      default: ''
    },
    color: {
      type   : String,
      default: ''
    },
    cardColor: {
      type   : String,
      default: ''
    },
    coloredBorder: {
      type   : Boolean,
      default: true
    },
    dark: {
      type: Boolean
    },
    dense: {
      type: Boolean
    },
    flat: {
      type: Boolean
    },
    tile: {
      type: Boolean
    },
    divider: {
      type: Boolean
    },
    elevation: {
      type   : [String, Number],
      default: undefined
    },
    toolbarExtended: {
      type   : Boolean,
      default: false
    },
    toolbarHeight: {
      type   : [String, Number],
      default: '64'
    },
    toolbarClass: {
      type   : String,
      default: ''
    },
    minWidth: {
      type   : [String, Number],
      default: undefined
    },
    maxWidth: {
      type   : [String, Number],
      default: undefined
    },
    width: {
      type   : [String, Number],
      default: undefined
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods : {}
}
</script>

<style scoped>

</style>
